export default "__VITE_ASSET__ojdjJ0fz__"